import React, { useEffect, useState } from "react";
import jotformLogo from '../../../assets/jotform.png';
import styles from "./JotformSetting.module.css"
import { Typography, Col, Row, Flex } from "antd";
import api from '../../../authentication/axiosInstance';
import moment from 'moment-timezone';
import { message } from 'antd';

const { Title, Text } = Typography;

export default function JotformSetting() {

    const [lastSync,setLastSync] = useState(null)

    const fetchConfig = async () => {
        try {
            const response = await api.get('/users/config/jotform/', {
                params: {
                    fields: 'last_sync'
                }
            });
            setLastSync(response.data.find(row => row.field === 'last_sync')?.value);
        } catch (error) {
            message.error('Error fetching configs');
        }
    }

    useEffect(() => {
        fetchConfig()
    },[])

    return (
    <Flex vertical justify="center" className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
            <Row align="middle" justify="space-between">
                <Col>
                    <Title level={2} className={styles.pageTitle}>
                        <img src={jotformLogo} className={styles.logo} alt="Jotform" /> Jotform Integration Settings
                    </Title>
                </Col>
            </Row>
        </div>

        <Flex vertical className={styles.settingContainer}>
            <Flex vertical align="flex-start" gap={6}>
                <Title level={4} className={styles.sectionTitle}>Syncing</Title>
                <Text className={styles.subtitle}>
                    New staff assessments arrive automatically when they're submitted. Use the Sync Jotform
                    button on the Staff Assessments page to bring everything else up to date.
                </Text>
                <Text className={styles.subtitle}>
                    Every sync copies all fields of every staff assessment submission from Jotform, so scores,
                    notes and full reports always match the form they came from.
                </Text>
                <Text className={styles.subtitle}>
                    Last synced: {lastSync ? moment(lastSync).format('MMM D, YYYY h:mm A') : 'Never'}
                </Text>
            </Flex>
        </Flex>
    </Flex>
    )
}
